export default __webpack_public_path__ + "static/media/lynnJumping.6476aa74.png";